<template>
  <div>
    <div class="header">
      <header-tag :title="'修改密码'"></header-tag>
    </div>
    <div class="form-body">
      <div class="form-left">
        <p>通行证账号:</p>
        <p>绑定手机号:</p>
        <p>短信验证码:</p>
        <p>新登录密码:</p>
        <p>确认新密码:</p>
        <p></p>
      </div>
      <div class="form-right">
        <p v-text="passportName"></p>
        <p v-text="phone"></p>
        <p style="position: relative;">
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="form.smsCode"
          />
          <span
            v-show="show"
            @click="showPwdModals"
          >获取验证码</span>
          <span v-show="!show">{{ count }} s</span>
        </p>
        <div class="img-code">
          <imgCode
            ref="imgcodePwd"
            @confirm="getResetCode"
          ></imgCode>
        </div>
        <p>
          <input
            type="password"
            placeholder="长度6-16位数字、英文大小写、符号任意两种以上组合"
            v-model="form.password"
          />
        </p>
        <p>
          <input
            type="password"
            placeholder="再次输入新密码"
            v-model="form.verifyPassword"
          />
        </p>
      </div>
    </div>
    <div class="footer">
      <span
        v-text="wrongText"
        ref="pwdWrong"
      ></span>
      <button @click="submitReset">重置密码</button>
      <button @click="closePwd">取消</button>
    </div>
  </div>
</template>
<script>
import { getResetPwd } from "@/requests/safe";
import { getResetSms } from "@/requests/safe";
import HeaderTag from "_c/tagTitle/headerTag";
import { mapState } from "vuex";
import imgCode from "_sc/imgCode";
export default {
  name: "changePwd",
  components: {
    HeaderTag,
    imgCode
  },
  data() {
    return {
      show: true,
      count: "",
      timer: null,
      showPwd: false,
      showImg: false,
      wrongText: "",
      form: {
        smsCode: "",
        password: "",
        verifyPassword: ""
      }
    };
  },
  computed: {
    ...mapState({
      passportName: state => state.user.userInfo.passportName,
      phone: state => state.user.userInfo.phone
    })
  },
  methods: {
    //关闭修改密码弹框
    closePwd() {
      this.showPwd = false;
      this.wrongText = "";
      this.form.smsCode = "";
      this.form.password = "";
      this.form.verifyPassword = "";
      this.$emit("showPwd", false);
    },
    //验证码倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    showPwdModals() {
      this.$refs.imgcodePwd.show();
    },
    async submitReset() {
      let smsRe = this.$validateCenter.smsCode(this.form.smsCode);
      if (smsRe.res == false) {
        this.wrongText = smsRe.msg;
        this.$domFn.shake(this.$refs.pwdWrong);
        return false;
      }
      let passwordRe = this.$validateCenter.passwordWhds(
        this.form.password
      );
      if (passwordRe.res == false) {
        this.wrongText = passwordRe.msg;
        this.$domFn.shake(this.$refs.pwdWrong);
        return false;
      }
      if (this.form.verifyPassword != this.form.password) {
        this.wrongText = "两次密码不一致";
        this.$domFn.shake(this.$refs.pwdWrong);
        return false;
      }
      let obj = this.form;
      obj.password = encodeURIComponent(obj.password);
      obj.verifyPassword = encodeURIComponent(obj.verifyPassword);
      let res = await getResetPwd(obj);
      if (res.code == 200) {
        this.closePwd();
        this.$router.go(0);
      } else {
        this.$domFn.shake(this.$refs.pwdWrong);
        this.wrongText = res.msg;
      }
    },
    async getResetCode(code) {
      let re = this.$validateCenter.imgCode(code);
      if (re.res == false) {
        this.wrongText = re.msg;
        return false;
      }
      let obj = {
        imgCode: code
      };
      let res = await getResetSms(obj);
      if (res.code == 200) {
        this.countDown();
        this.$refs.imgcodePwd.hide();
      } else {
        this.wrongText = res.msg;
      }
    }
  },
  mounted() {
    //监听键盘按键事件
    let self = this
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.closePwd()
        }
      })
    })
  }
};
</script>
<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}
.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;
  button {
    width: 100px;
    line-height: 30px;
  }
  button:nth-child(2) {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }
  button:nth-child(3) {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
  }
  span {
    float: left;
    padding-left: 50px;
    line-height: 30px;
    color: #f00;
  }
}
.form-body {
  overflow: hidden;
  width: 100%;
  padding: 10px 0px 20px 0px;
  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }
  .form-right {
    float: left;
    padding-left: 15px;
    width: 300px;
    text-align: left;
    line-height: 40px;
    input {
      width: 100%;
      height: 30px;
      padding-left: 10px;
      border: 1px solid #d9dee4;
    }
    span {
      position: absolute;
      top: 0px;
      right: 0px;
      // transform: translate(240px,-40px);
      color: rgb(0, 102, 204);
      cursor: pointer;
      z-index: 11;
    }
  }
  .img-code {
    position: absolute;
    top: 160px;
    right: 90px;
    width: 140px;
    height: 95px;
  }
}
</style>
